




























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'FDialog'
})
class FDialog extends Vue {
  @Prop() readonly eventName?: string

  private showDialog = false

  private get hasTriggerCaption(): boolean {
    return !!this.$slots.triggerCaption
  }

  private get hasTriggerButton(): boolean {
    return !!this.$slots.triggerButton
  }

  private get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown
  }

  private mounted(): void {
    if (this.eventName) {
      document.addEventListener(this.eventName, () => {
        this.showDialog = false
      })
    }
  }

  public toggleDialog(): void {
    this.showDialog = !this.showDialog
  }
}

export default FDialog
